import React, { Component } from "react";
import {
	View,
	StyleSheet,
	KeyboardAvoidingView,
	TextInput,
	Alert,
	Platform,
	Image,
	ScrollView,
} from "react-native";
import { translate } from "react-i18next";

import { Storage } from "utils/storage";
import { addDevice, getLocal } from "api";
import { reset, push, pushToHttps } from "utils/navigation";
import { DeviceRegisterIP } from "utils/config";
import BackgroundImage from "components/BackgroundImage";
import KeyboardView from "components/KeyboardView";
import ViewScroll from "components/ViewScroll";
import Button from "components/Button";
import Header from "components/Header";
import Text from "components/StyledText";
import { AppURL } from "utils/config";

import * as x from "../../../styles/css";

class ConnectSuccess extends Component {
	static navigationOptions = {
		header: null,
	};

	static isPrivate = true;
	static bypass = true;

	constructor(props) {
		super(props);

		this.state = {
			loading: false,
		};

		this.connected = this.connected.bind(this);
	}

	async connected() {
		this.setState({
			loading: true,
		});

		let deviceId = null;
		if (Platform.OS === "web") {
			if (this.props.match.params.deviceId) {
				deviceId = this.props.match.params.deviceId;
			}
		} else {
			const storage = new Storage();
			deviceId = await storage.getItem("deviceId");
		}

		getLocal(`https://${AppURL}/connect/poll/${deviceId}`)
			.then(() => {
				{
					push(
						{
							mobile: "ConnectPoll",
							web: `/connect/poll/${deviceId}`,
						},
						this.props,
						false,
						true
					);
				}
			})
			.catch(err => {
				window.alert("Not connected to network, please try again");
				this.setState({
					loading: false,
				});
			});
	}

	render() {
		const nav = this.props.navigation;

		const { t } = this.props;

		return (
			<ViewScroll>
				<Header>{t("deviceAuth.connectSuccess.title")}</Header>
				<Text>{t("deviceAuth.connectSuccess.help")}</Text>
				<View style={[x.mt.auto]}>
					<Button
						disabled={this.state.loading}
						onPress={this.connected}
						title={t("labels.reconnected")}
						color={x.colors.default}
					/>
				</View>
			</ViewScroll>
		);
	}
}

export default translate()(ConnectSuccess);



// WEBPACK FOOTER //
// ./src/views/DeviceAuth/ConnectSuccess/index.js